// Cards shown in the "Education" and "Experience" tabs of the resume.
// `color` accepts a Vuetify color name ("cyan darken-1") or a hex value.

// End of an ongoing period: the current month, as "Oct 2026".
const thisMonth = new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(Date.now());

export const education = [
    {
        title: 'Physician',
        icon: 'mdi-stethoscope',
        color: 'primary',
        details: [
            { label: 'Grade', value: 'Doctorate' },
            { label: 'Period', value: '2009 - 2017' },
        ],
        quote: 'A very long journey, full of turns and twists but giving a lot of discipline and wisdom. It shaped who I am.',
    },
    {
        title: 'Software Engineering',
        icon: 'mdi-code-braces',
        color: '#3289D6',
        details: [
            { label: 'Grade', value: 'Master II' },
            { label: 'Period', value: '2009 - 2015' },
        ],
        quote: 'A passion? I loved the world of computers and technology.',
    },
    {
        title: 'Certifications',
        icon: 'mdi-code-braces',
        color: 'cyan darken-1',
        links: [
            {
                label: 'JavaScript Algorithms and Data Structures',
                url: 'https://www.freecodecamp.org/certification/r_ruddy/javascript-algorithms-and-data-structures',
            },
            {
                label: 'Machine Learning',
                url: 'https://www.freecodecamp.org/certification/r_ruddy/machine-learning-with-python-v7',
            },
        ],
        quote: "I was stuck in the flow. I couldn't stop. The more I learned, the more I wanted.",
    },
];

// Newest first. The colors step from primary to teal, so the list reads as one gradient.
export const experience = [
    {
        title: 'Theia, France',
        icon: 'mdi-shield-check',
        color: '#6258D8',
        details: [
            { label: 'Role', value: 'Full-Stack Developer' },
            { label: 'Period', value: `Oct 2025 - ${thisMonth}` },
        ],
        quote: 'Online exams must be fair, and I loved maintaining the tools that keep them that way.',
    },
    {
        title: 'Great Ponton, Ireland',
        icon: 'mdi-code-braces',
        color: '#546ED7',
        details: [
            { label: 'Role', value: 'Lead Front-End Developer and Data Engineer' },
            { label: 'Period', value: 'Jul 2023 - Sep 2025' },
        ],
        quote: 'Freelancing has been a success for me, but working with the Great Ponton team has given me a lot of knowledge and wisdom.',
    },
    {
        title: 'Gamecam, Sweden',
        icon: 'mdi-tennis-ball',
        color: '#3D83D6',
        details: [
            { label: 'Role', value: 'Full-Stack and Computer Vision Developer' },
            { label: 'Period', value: 'Oct 2022 - Sep 2023' },
        ],
        quote: 'Following a tennis ball in real time is harder than it looks. I trained the models that track the players and the ball, and built the back office around them.',
    },
    {
        title: 'Meridius',
        icon: 'mdi-account-tie',
        color: '#2A93D0',
        details: [
            { label: 'Role', value: 'CEO' },
            { label: 'Period', value: 'Oct 2021 - Today' },
        ],
        quote: "Turns out the demand on the IT world keeps increasing, it's time to move into the next gear. I turned my passion into a career.",
    },
    {
        title: 'Smart Invest, France',
        icon: 'mdi-finance',
        color: '#18A2C7',
        details: [
            { label: 'Role', value: 'Full-Stack Developer' },
            { label: 'Period', value: 'Mar 2020 - Jul 2022' },
        ],
        quote: 'I led the development of a trading platform with live charts. More than 50,000 users at the same time, so every millisecond counted.',
    },
    {
        title: 'Qualitext, France',
        icon: 'mdi-text-search',
        color: '#00A9B9',
        details: [
            { label: 'Role', value: 'Front-End Developer and Data Engineer' },
            { label: 'Period', value: 'Mar 2019 - Mar 2020' },
        ],
        quote: 'Catching plagiarism takes a lot of data. I built the interface of the tool, then the pipelines. Performance management was tought',
    },
    {
        title: 'Cetamada, Madagascar',
        icon: 'mdi-fish',
        color: '#00A0A0',
        details: [
            { label: 'Role', value: 'Full-Stack Developer' },
            { label: 'Period', value: 'Feb 2019 - Mar 2019' },
        ],
        quote: 'A short mission at home, in Madagascar. I built an e-learning platform to train the people who observe whales and other giants of the sea.',
    },
    {
        title: 'Freelancer',
        icon: 'mdi-code-braces',
        color: '#009688',
        details: [
            { label: 'Role', value: 'AI Engineering - Full-stack developer' },
            { label: 'Period', value: '2015 - 2021' },
        ],
        quote: 'I started my IT journey on AI development as a freelancer. I had no choice, I had studies to finish. It was hard but I persevered.',
    },
];
